import { render, staticRenderFns } from "./filter-item.vue?vue&type=template&id=8b891248"
import script from "./filter-item.vue?vue&type=script&lang=js"
export * from "./filter-item.vue?vue&type=script&lang=js"
import style0 from "./filter-item.vue?vue&type=style&index=0&id=8b891248&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports